import { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';

// Runtime detection - works in both localhost and production
const API = (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
  ? 'http://localhost:8001/api' 
  : '/api';

function HeatMapPage({ user, setUser }) {
  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAssets();
  }, []);

  const fetchAssets = async () => {
    try {
      const response = await axios.get(`${API}/assets`);
      // Filter VIOP, BIST_100, and other Turkish stocks
      const turkishAssets = response.data.filter(a => 
        a.category === 'VIOP' || 
        a.category === 'BIST_100' || 
        a.category === 'BORSA_ISTANBUL' ||
        a.category === 'ENDEKSLER'
      );
      setAssets(turkishAssets);
    } catch (err) {
      console.error('Assets fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  const getColorByChange = (change) => {
    if (change > 5) return 'bg-green-600';
    if (change > 2) return 'bg-green-500';
    if (change > 0) return 'bg-green-400';
    if (change > -2) return 'bg-red-400';
    if (change > -5) return 'bg-red-500';
    return 'bg-red-600';
  };

  const getSizeByVolume = (index) => {
    const sizes = ['col-span-2 row-span-2', 'col-span-1 row-span-1', 'col-span-1 row-span-2', 'col-span-2 row-span-1'];
    return sizes[index % sizes.length];
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <Navbar user={user} setUser={setUser} />
      
      <div className="max-w-7xl mx-auto p-4">
        <div className="mb-6">
          <h1 className="text-2xl sm:text-3xl font-bold mb-2">🔥 Piyasa Isı Haritası</h1>
          <p className="text-gray-400 text-sm sm:text-base">VIOP, BIST-100 ve Endeksler - Anlık Durum</p>
        </div>

        {loading ? (
          <div className="flex items-center justify-center h-64">
            <div className="text-xl">Yükleniyor...</div>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-2 auto-rows-fr">
            {assets.map((asset, idx) => (
              <div
                key={asset.id}
                className={`${
                  getColorByChange(asset.change_percent)
                } ${getSizeByVolume(idx)} p-3 sm:p-4 rounded-lg flex flex-col justify-between hover:opacity-90 transition-opacity cursor-pointer min-h-[100px] sm:min-h-[120px]`}
              >
                <div>
                  <div className="font-bold text-sm sm:text-base">{asset.symbol}</div>
                  <div className="text-xs text-white/80 truncate">{asset.name}</div>
                </div>
                <div className="mt-2">
                  <div className="text-lg sm:text-xl font-bold">₺{asset.current_price.toFixed(2)}</div>
                  <div className="text-sm sm:text-base font-semibold">
                    {asset.change_percent > 0 ? '+' : ''}{asset.change_percent.toFixed(2)}%
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Legend */}
        <div className="mt-8 bg-gray-800 rounded-lg p-4">
          <h3 className="font-bold mb-3 text-sm sm:text-base">Renk Açıklaması</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2 text-xs sm:text-sm">
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-green-600 rounded"></div>
              <span>&gt; +5%</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-green-500 rounded"></div>
              <span>+2% ~ +5%</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-green-400 rounded"></div>
              <span>0% ~ +2%</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-red-400 rounded"></div>
              <span>0% ~ -2%</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-red-500 rounded"></div>
              <span>-2% ~ -5%</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-red-600 rounded"></div>
              <span>&lt; -5%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeatMapPage;
